export const articles = [
  {
    "title": "Applying LSTM Models to Financial Time Series",
    "id": "lstm-financial-time-series",
    "desc": "An overview of how Long Short-Term Memory networks can be used to model market trends and capture long-term dependencies in price data.",
    "date": "2024-03-12",
    "dateModified": "2024-03-12",
    "link": "https://medium.com/@axionquant/applying-lstm-models-to-financial-time-series-9c5cea00c409",
    "img": "/articles/lstm-financial-time-series.webp",
    "readTime": '5 min read'
  },
  {
    "title": "Linear Regression as a Baseline for Market Prediction",
    "id": "linear-regression-market-baseline",
    "desc": "Why simple linear regression still matters in financial modeling and how it serves as a benchmark for more complex models.",
    "date": "2024-08-27",
    "dateModified": "2024-08-27",
    "link": "https://medium.com/@axionquant/linear-regression-as-a-baseline-for-market-prediction-a55f144c67a0",
    "img": "/articles/linear-regression-market-baseline.webp",
    "readTime": '5 min read'
  },
  {
    "title": "Visualizing the Entire Market at Once",
    "id": "market-visualization-techniques",
    "desc": "Techniques and tools for building large-scale visualizations that capture sector, asset, and index-level market behavior.",
    "date": "2025-01-05",
    "dateModified": "2025-01-05",
    "link": "https://medium.com/@axionquant/visualizing-the-entire-market-at-once-techniques-and-tools-for-building-large-scale-market-fbc6896d84cf",
    "img": "/articles/market-visualization-techniques.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Modern Portfolio Optimization in Practice",
    "id": "modern-portfolio-optimization",
    "desc": "A practical guide to portfolio optimization using risk, return, and correlation data to improve allocation decisions.",
    "date": "2025-06-19",
    "dateModified": "2025-06-19",
    "link": "https://medium.com/@axionquant/modern-portfolio-optimization-in-practice-from-theory-to-actionable-insights-891d3ceb1965",
    "img": "/articles/modern-portfolio-optimization.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Outlier Detection in Market Data",
    "id": "outlier-detection-market-data",
    "desc": "How to detect anomalies in financial time series and why outliers often signal structural changes or rare events.",
    "date": "2024-11-03",
    "dateModified": "2024-11-03",
    "link": "https://medium.com/@axionquant/outlier-detection-in-market-data-b455b435777d",
    "img": "/articles/outlier-detection-market-data.webp",
    "readTime": '6 min read'
  },
  {
    "title": "US Politics and Market Predictions",
    "id": "politics-market-predictions",
    "desc": "An analysis of how elections, legislation, and political uncertainty influence market sentiment and price movements.",
    "date": "2024-02-14",
    "dateModified": "2024-02-14",
    "link": "https://medium.com/@axionquant/us-politics-and-market-predictions-59a7ffbf2e5d",
    "img": "/articles/politics-market-predictions.webp",
    "readTime": '8 min read'
  },
  {
    "title": "Using Web Traffic as a Market Signal",
    "id": "web-traffic-market-signals",
    "desc": "Exploring how website traffic, search trends, and online engagement can be transformed into predictive indicators.",
    "date": "2025-09-09",
    "dateModified": "2025-09-09",
    "link": "https://medium.com/@axionquant/using-web-traffic-as-a-market-signal-2d0abd59330e",
    "img": "/articles/web-traffic-market-signals.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Sporting Events and Their Impact on Stocks",
    "id": "sports-events-stock-impact",
    "desc": "A look at how major sporting events can affect consumer behavior, brand exposure, and related stock performance.",
    "date": "2024-07-21",
    "dateModified": "2024-07-21",
    "link": "https://medium.com/@axionquant/sporting-events-and-their-impact-on-stocks-f1fb6281d95f",
    "img": "/articles/sports-events-stock-impact.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Seasonal Stocks and Cyclical Patterns",
    "id": "seasonal-market-patterns",
    "desc": "Identifying seasonal trends in equities and commodities and incorporating them into trading strategies.",
    "date": "2025-12-02",
    "dateModified": "2025-12-02",
    "link": "https://medium.com/@axionquant/seasonal-stocks-and-cyclical-patterns-4bd5d18bf5b4",
    "img": "/articles/seasonal-market-patterns.webp",
    "readTime": '7 min read'
  },
  {
    "title": "How Disasters and Weather Affect Markets",
    "id": "disasters-weather-market-effects",
    "desc": "An examination of how extreme weather and natural disasters influence supply chains, commodities, and equities.",
    "date": "2024-05-18",
    "dateModified": "2024-05-18",
    "link": "https://medium.com/@axionquant/how-disasters-and-weather-affect-markets-66892df1abdb",
    "img": "/articles/disasters-weather-market-effects.webp",
    "readTime": '5 min read'
  },
  // {
  //   "title": "The Ultimate Jupyter Setup for Market Analysis",
  //   "desc": "A deep dive into configuring Jupyter, terminals, and extensions for efficient financial research and analysis.",
  //   "date": "2022-10-30",
  //   "link": "https://example.com/articles/jupyter-market-setup",
  //   "img": "/articles/jupyter.webp",
  //   "readTime": '10 min read'
  // },
  {
    "title": "How Legal Changes Affect Stock Prices",
    "id": "legal-regulatory-market-impact",
    "desc": "Understanding the relationship between regulatory actions, lawsuits, and their short- and long-term market effects.",
    "date": "2026-04-07",
    "dateModified": "2026-04-07",
    "link": "https://medium.com/@axionquant/how-legal-changes-affect-stock-prices-d6e7024fba7e",
    "img": "/articles/legal-regulatory-market-impact.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Using Foreign Exchange to Predict Regional Markets",
    "id": "forex-regional-market-analysis",
    "desc": "How FX movements can serve as leading indicators for regional equity and bond market performance.",
    "date": "2026-01-25",
    "dateModified": "2026-01-25",
    "link": "https://medium.com/@axionquant/using-foreign-exchange-to-predict-regional-markets-4a6ed86c0b82",
    "img": "/articles/forex-regional-market-analysis.webp",
    "readTime": '5 min read'
  },
  {
    "title": "Using Beta to Find Supply Chain Correlations",
    "id": "beta-supply-chain-correlations",
    "desc": "Applying beta and correlation analysis to uncover relationships between companies linked by supply chains.",
    "date": "2026-06-11",
    "dateModified": "2026-06-11",
    "link": "https://medium.com/@axionquant/using-beta-to-find-supply-chain-correlations-c303497cd16a",
    "img": "/articles/beta-supply-chain-correlations.webp",
    "readTime": '6 min read'
  },
  {
    "title": "RAG for Corporate Profiles and Intelligence",
    "id": "rag-corporate-intelligence",
    "desc": "Using retrieval-augmented generation to build richer, more accurate corporate profiles from unstructured data.",
    "date": "2024-09-16",
    "dateModified": "2024-09-16",
    "link": "https://medium.com/@axionquant/rag-for-corporate-profiles-and-intelligence-4173deacd364",
    "img": "/articles/rag-corporate-intelligence.webp",
    "readTime": '7 min read'
  },
  {
    "title": "Using Economic Data for Market Insights",
    "id": "macroeconomic-market-insights",
    "desc": "How macroeconomic indicators like CPI, GDP, and employment data can be leveraged for market analysis.",
    "date": "2025-02-28",
    "dateModified": "2025-02-28",
    "link": "https://medium.com/@axionquant/using-economic-data-for-market-insights-0fce42eec77c",
    "img": "/articles/macroeconomic-market-insights.webp",
    "readTime": '6 min read'
  },
  {
    "title": "Using AI to Extract Advanced Market Metrics",
    "id": "ai-financial-metrics-extraction",
    "desc": "An exploration of AI-driven techniques for deriving complex financial metrics from raw market and alternative data.",
    "date": "2024-08-04",
    "dateModified": "2024-08-04",
    "link": "https://medium.com/@axionquant/using-ai-to-extract-advanced-market-metrics-7ce7a046601f",
    "img": "/articles/ai-financial-metrics-extraction.webp",
    "readTime": '5 min read'
  }
]
